// extracted by mini-css-extract-plugin
module.exports = {"summary":"CompositionTable_summary__1O34m","labelKeys":"CompositionTable_labelKeys__30GDq"};